<template>
  <!-- 购买会员产品页面 -->
  <div>
    <div class="app_wrap">

      <!-- !is_wap  wap用不到  -->
      <div class="invite" v-show="!is_wap && igp_invite_setting > 0">
        <div class="invite_img" @click="goPage('invite_members',{
        l_id:l_id,
      })"></div>
        <div class="in_close" @click.self.stop="in_close()"></div>
      </div>

      <!-- 会员产品信息 -->
      <div class="live_wrap">
        <div class="live_img" :style="{'background-image':'url('+livers.image+')'}"></div>
        <div class="live_c">
          <h1>产品名称:{{livers.title}}的会员服务</h1>
          <p>{{ livers.intro && livers.intro.length> max_num ? livers.intro.slice(0,max_num)+'...' : livers.intro }}</p>
          <p>产品评级:{{ livers.product_level }}</p>
        </div>
      </div>

      <!-- 风险评估 -->
      <div class="buy_wrap" @click="goPage('risk_assessment',{
        l_id:l_id,
      })">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#EB6788"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4991 6.63271H8.50095C8.08645 6.63271 7.74966 6.29592 7.74966 5.88141V5.87788C7.74966 5.46337 8.08645 5.12659 8.50095 5.12659H11.4991C11.9136 5.12659 12.2504 5.46337 12.2504 5.87788V5.88141C12.2504 6.29592 11.9136 6.63271 11.4991 6.63271ZM12.7497 5.86964H13.2866C13.952 5.86964 14.4913 6.40897 14.4925 7.07548V13.6676C14.4925 14.3341 13.952 14.8734 13.2866 14.8734H6.71339C6.04688 14.8734 5.50755 14.3329 5.50755 13.6676V7.07548C5.50755 6.40897 6.04806 5.86964 6.71339 5.86964H7.25037V5.87906C7.25037 6.57147 7.81207 7.132 8.50331 7.132H11.4967C12.1891 7.132 12.7497 6.5703 12.7497 5.87906V5.86964ZM7.50423 8.4485C7.26103 8.4485 7.06389 8.64565 7.06389 8.88884C7.06389 9.13203 7.26103 9.32918 7.50423 9.32918H12.4958C12.739 9.32918 12.9361 9.13203 12.9361 8.88884C12.9361 8.64565 12.739 8.4485 12.4958 8.4485H7.50423ZM7.06389 10.5971C7.06389 10.3539 7.26103 10.1568 7.50423 10.1568H12.4958C12.739 10.1568 12.9361 10.3539 12.9361 10.5971C12.9361 10.8403 12.739 11.0375 12.4958 11.0375H7.50423C7.26103 11.0375 7.06389 10.8403 7.06389 10.5971ZM7.50423 12.0359C7.26103 12.0359 7.06389 12.233 7.06389 12.4762C7.06389 12.7194 7.26103 12.9166 7.50423 12.9166H12.4958C12.739 12.9166 12.9361 12.7194 12.9361 12.4762C12.9361 12.233 12.739 12.0359 12.4958 12.0359H7.50423Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>{{ user_survey.title }}</h1>
          <p>{{ user_survey.intro }}</p>
        </div>
        <div class="buy_close">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="25" viewBox="0 0 13 25" fill="none">
            <path d="M3.45001 6.37142L9.80111 12.1533C9.93548 12.2756 9.93754 12.4864 9.80558 12.6113L3.45001 18.6286" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- 选择会员分组（只有一个会默认选择分组） -->
      <div class="buy_wrap buy_wrap_h">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#ED726D"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1147 6.27049L11.0217 5.29502C10.9991 5.27494 10.9829 5.24876 10.9749 5.21965C10.9669 5.19054 10.9674 5.15973 10.9765 5.13095C10.9856 5.10216 11.0029 5.07661 11.0261 5.05739C11.0494 5.03817 11.0778 5.0261 11.1078 5.02262L14.1611 4.66725C14.1831 4.66468 14.2053 4.6668 14.2264 4.67345C14.2475 4.6801 14.2669 4.69114 14.2834 4.70584C14.2999 4.72054 14.3131 4.73857 14.3222 4.75874C14.3312 4.7789 14.3359 4.80076 14.3359 4.82286V7.90317C14.3359 7.93338 14.3271 7.96294 14.3107 7.9883C14.2943 8.01365 14.2709 8.03371 14.2433 8.04606C14.2157 8.0584 14.1852 8.06251 14.1553 8.05788C14.1255 8.05324 14.0976 8.04007 14.075 8.01995L13.0998 7.14957C12.6601 7.56396 11.966 8.00819 11.0176 8.48241C9.76519 9.10862 7.96485 9.44771 5.61658 9.5C7.65175 8.92608 9.113 8.37815 10 7.85621C10.7221 7.43129 11.427 6.90283 12.1147 6.27049ZM14.1584 9.05104H12.8083C12.6583 9.05104 12.5833 9.15541 12.5833 9.36414V14.6869C12.5833 14.8956 12.6583 15 12.8083 15H14.1584C14.3084 15 14.3834 14.8956 14.3834 14.6869V9.36414C14.3834 9.15541 14.3084 9.05104 14.1584 9.05104ZM9.25798 10.3034H10.5991C10.7482 10.3034 10.8227 10.4078 10.8227 10.6165V14.6869C10.8227 14.8956 10.7482 15 10.5991 15H9.25798C9.10896 15 9.03445 14.8956 9.03445 14.6869V10.6165C9.03445 10.4078 9.10896 10.3034 9.25798 10.3034ZM5.84111 11.869H7.18837C7.33807 11.869 7.41292 11.9733 7.41292 12.1821V14.6869C7.41292 14.8956 7.33807 15 7.18837 15H5.84111C5.69141 15 5.61656 14.8956 5.61656 14.6869V12.1821C5.61656 11.9733 5.69141 11.869 5.84111 11.869Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>选择会员分组</h1>
        </div>  
        <div class="buy_close" @click="click_groups()">
          <h1>
            {{
              groups_num > -1 ? 
              ( is_order_buy ?
                current_group.g_name+'（预约）' 
                  : 
                current_group.g_name): 
              '请选择分组'}}
            
          </h1>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
            <path d="M15.1286 7.70001L9.34671 14.0511C9.22438 14.1855 9.01363 14.1875 8.88869 14.0556L2.87146 7.70001" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- 选择服务期限 -->
      <div class="buy_wrap buy_wrap_no" @click="show_vips = !show_vips">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#E39A45"/>
          <path d="M5.05737 13.6761V7.18888C5.05737 6.50643 5.61058 5.95323 6.29303 5.95323H13.707C14.3894 5.95323 14.9426 6.50643 14.9426 7.18888V13.6761C14.9426 14.3585 14.3894 14.9117 13.707 14.9117H6.29303C5.61058 14.9117 5.05737 14.3585 5.05737 13.6761ZM5.79877 13.6761C5.79877 13.7389 5.81034 13.7996 5.83349 13.858C5.85861 13.9215 5.89529 13.9773 5.94352 14.0256C5.9918 14.0738 6.04765 14.1105 6.11108 14.1356C6.16953 14.1588 6.23018 14.1703 6.29303 14.1703H13.707C13.7698 14.1703 13.8305 14.1588 13.8889 14.1356C13.9523 14.1105 14.0082 14.0738 14.0565 14.0256C14.1047 13.9773 14.1414 13.9215 14.1665 13.858C14.1897 13.7996 14.2012 13.7389 14.2012 13.6761V7.18888C14.2012 7.12603 14.1897 7.06538 14.1665 7.00693C14.1414 6.9435 14.1047 6.88765 14.0565 6.83938C14.0082 6.79115 13.9523 6.75447 13.8889 6.72934C13.8305 6.7062 13.7698 6.69462 13.707 6.69462H6.29303C6.23018 6.69462 6.16953 6.7062 6.11108 6.72934C6.04765 6.75447 5.9918 6.79115 5.94352 6.83938C5.89529 6.88765 5.85861 6.9435 5.83349 7.00693C5.81034 7.06542 5.79877 7.12607 5.79877 7.18888V13.6761ZM7.77582 5.45897C7.77582 5.36065 7.81487 5.26636 7.88439 5.19684C7.95391 5.12732 8.0482 5.08827 8.14651 5.08827C8.24483 5.08827 8.33912 5.12732 8.40864 5.19684C8.47815 5.26636 8.51721 5.36065 8.51721 5.45897V7.31245C8.51721 7.41076 8.47815 7.50505 8.40864 7.57457C8.33912 7.64409 8.24483 7.68315 8.14651 7.68315C8.0482 7.68315 7.95391 7.64409 7.88439 7.57457C7.81487 7.50505 7.77582 7.41076 7.77582 7.31245V5.45897ZM11.5446 5.45897C11.5446 5.36065 11.5836 5.26636 11.6531 5.19684C11.7227 5.12732 11.8169 5.08827 11.9153 5.08827C12.0136 5.08827 12.1079 5.12732 12.1774 5.19684C12.2469 5.26636 12.286 5.36065 12.286 5.45897V7.31245C12.286 7.41076 12.2469 7.50505 12.1774 7.57457C12.1079 7.64409 12.0136 7.68315 11.9153 7.68315C11.8169 7.68315 11.7227 7.64409 11.6531 7.57457C11.5836 7.50505 11.5446 7.41076 11.5446 7.31245V5.45897ZM14.5101 8.98058H5.52074V8.23919H14.5101V8.98058ZM9.69108 10.278H8.70256V9.53663H9.69108V10.278ZM11.2974 10.278H10.3089V9.53663H11.2974V10.278ZM12.9656 10.278H11.977V9.53663H12.9656V10.278ZM9.69108 11.699H8.70256V10.9576H9.69108V11.699ZM8.02295 11.699H7.03442V10.9576H8.02295V11.699ZM11.2974 11.699H10.3089V10.9576H11.2974V11.699ZM12.9656 11.699H11.977V10.9576H12.9656V11.699ZM9.69108 13.0582H8.70256V12.3169H9.69108V13.0582ZM8.02295 13.0582H7.03442V12.3169H8.02295V13.0582ZM11.2974 13.0582H10.3089V12.3169H11.2974V13.0582Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>选择服务期限</h1>
        </div>  
        <div class="buy_close">
          <h1 class="red red_mini">{{current_product.choose_label}}</h1>
          <svg v-show="show_vips" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
            <path d="M15.1286 14.3L9.34671 7.94891C9.22438 7.81454 9.01363 7.81248 8.88869 7.94444L2.87146 14.3" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-show="!show_vips" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
            <path d="M15.1286 7.70001L9.34671 14.0511C9.22438 14.1855 9.01363 14.1875 8.88869 14.0556L2.87146 7.70001" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <div class="vip_wrap"  >
        <div class="vip_wrap2" v-show="show_vips">
          <div class="vip_item" v-for="(item,i) in products"
            :class="[products_num == i ? 'vip_item2':'']"
            @click="choose_product(i)"
            >
            <div class="vip_l">
              <h1>{{ item.pro_label }}</h1>
              <h2>{{ item.pro_intro }}</h2>
            </div>
            <div class="vip_r">
              
              <h1 v-if="coupon_sub_amount > 0">
                <span v-if="item.give_day_label">{{ item.give_day_label }}</span>
                {{ item.mkt_price }}元
              </h1>

              <h1  v-else>
                <span v-if="item.sale_label">{{ item.sale_label }}</span>
                {{ item.sale_amount_intro }}
              </h1>

              <h2 v-if="!(coupon_sub_amount > 0) && item.sale_amount != item.mkt_price">{{ item.mkt_amount }}</h2>
            </div>
          </div>
        </div>
        <p v-if="current_product.pro_label != '月付费'">温馨提示：若单笔支付超过微信或支付宝限额，您可以选择分批次充值金币，开通会员时勾选使用金币，即可成功开通。
          <span class="red" @click="goPage('account',{url:'/up/app/account'})">立即充值</span>
        </p>
      </div>

      <div class="buy_wrap" v-show='
          (is_order_buy)'>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <circle cx="10" cy="10.5" r="10" fill="#4DABE9"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.11539 5.50002H12.8846C13.0886 5.50002 13.2843 5.58106 13.4285 5.72532C13.5728 5.86958 13.6538 6.06523 13.6538 6.26925V7.2329C13.6538 7.89834 13.4073 8.54019 12.9619 9.03463L11.6415 10.5006L12.9615 11.965C13.3902 12.4407 13.6353 13.0536 13.6529 13.6937L13.6538 13.7675V14.7308C13.6538 14.9348 13.5728 15.1304 13.4285 15.2747C13.2843 15.419 13.0886 15.5 12.8846 15.5H7.11539C6.91138 15.5 6.71572 15.419 6.57146 15.2747C6.4272 15.1304 6.34616 14.9348 6.34616 14.7308V13.7673C6.34625 13.1016 6.59288 12.4596 7.03847 11.965L8.35827 10.5006L7.03808 9.03463C6.60972 8.55909 6.36476 7.94652 6.34712 7.30674L6.34616 7.2329V6.26925C6.34616 6.06523 6.4272 5.86958 6.57146 5.72532C6.71572 5.58106 6.91138 5.50002 7.11539 5.50002ZM12.8846 6.26925H7.11539V7.23271C7.11536 7.70815 7.29143 8.16675 7.60962 8.52001L9.16193 10.2435C9.22555 10.3141 9.26076 10.4058 9.26076 10.5009C9.26076 10.5959 9.22555 10.6876 9.16193 10.7583L7.61001 12.48C7.29174 12.8333 7.11539 13.2921 7.11539 13.7675V14.7308H12.8846V13.7675C12.8845 13.292 12.7083 12.8333 12.39 12.48L10.8381 10.7583C10.7745 10.6876 10.7392 10.5959 10.7392 10.5009C10.7392 10.4058 10.7745 10.3141 10.8381 10.2435L12.3904 8.52001C12.7085 8.16674 12.8846 7.70809 12.8846 7.2329V6.26925ZM11.9231 13.5769V13.1923H8.07694V13.5769C8.07694 13.6274 8.08688 13.6774 8.10621 13.7241C8.12554 13.7708 8.15387 13.8132 8.18959 13.8489C8.2253 13.8846 8.2677 13.9129 8.31436 13.9323C8.36103 13.9516 8.41104 13.9615 8.46155 13.9615H11.5385C11.589 13.9615 11.639 13.9516 11.6857 13.9323C11.7323 13.9129 11.7747 13.8846 11.8104 13.8489C11.8461 13.8132 11.8745 13.7708 11.8938 13.7241C11.9131 13.6774 11.9231 13.6274 11.9231 13.5769Z" fill="white"/>
          </svg>

          <span class="buy_wrap_no2span">{{ current_group.places_tips }}</span>

          <h1>预计等待:{{ current_group.count_down }}</h1>

      </div>

      <p class="order_open2" v-show='
          (is_order_buy)'>
        {{ '预约说明：支付预约金后可进入排队通道，当现存会员到期后，我们会优先为您开通您预约的会员服务。开通时会有系统消息通知，请确保您的app通知为开启状态。' }}
      </p>


      <!-- 使用金币(这里会调用接口判断 能否使用全部金币  不能会弹窗)-->
      <div class="buy_wrap buy_wrap_no2 buy_wrap_h" v-show='
          !(is_order_buy)'>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#EEB442"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0344 4.97355C10.7514 4.66477 10.3896 4.5 9.98248 4.5L9.8837 4.50508C9.49554 4.53739 9.18584 4.72201 8.9486 4.98925L8.90014 5.04694L8.81475 5.00263C8.63982 4.91863 8.46858 4.87524 8.30335 4.87524C8.01165 4.87524 7.73518 4.99755 7.51871 5.28556C7.31332 5.54265 7.23301 5.8722 7.28701 6.23082L7.31055 6.35313C7.39224 6.7196 7.58379 7.06346 7.83026 7.36809L7.83672 7.37639L7.66964 7.49178C6.32883 8.43889 5.34295 9.73123 5.28295 11.343C5.25156 12.3801 5.49619 13.1901 6.01682 13.7477C6.53053 14.2941 7.19562 14.5 7.83349 14.5H12.1652L12.2782 14.4981C12.881 14.4746 13.4981 14.2623 13.9814 13.7481C14.5094 13.1906 14.7549 12.3792 14.7157 11.3421L14.6003 11.3467H14.5994L14.7148 11.3421L14.7065 11.1888C14.5878 9.61538 13.5614 8.3415 12.1979 7.4027L12.161 7.37778L12.2496 7.26562C12.497 6.93284 12.6622 6.56683 12.7112 6.2299C12.7656 5.87635 12.6886 5.54819 12.4878 5.28602C12.2709 4.99755 11.9935 4.87478 11.7013 4.87478L11.6145 4.87847C11.4691 4.89093 11.321 4.93432 11.177 5.00632L11.0985 5.04786L11.0344 4.97355ZM8.67259 7.92703L8.70398 7.9081L8.73628 7.91595C8.75873 7.9208 8.78163 7.92328 8.80459 7.92333H11.2093L11.2582 7.91872L11.2933 7.91133L11.4022 7.97595C11.5079 8.04057 11.6279 8.11903 11.759 8.21134C12.0553 8.42089 12.3452 8.66089 12.611 8.92859C13.3393 9.66015 13.781 10.4826 13.8124 11.3817C13.8401 12.1696 13.6749 12.7539 13.3283 13.1218C13.0116 13.4573 12.5815 13.5861 12.1652 13.5861H7.83303L7.73702 13.5838C7.35163 13.5653 6.96254 13.432 6.66945 13.1227C6.32329 12.7544 6.15805 12.1678 6.18575 11.3744C6.2199 10.49 6.66299 9.67077 7.39224 8.93459C7.65902 8.66505 7.94841 8.42319 8.24519 8.20996C8.40904 8.09226 8.55397 7.9981 8.67259 7.92703ZM9.58231 5.63911C9.69585 5.4988 9.83386 5.41618 10.0009 5.41387C10.1593 5.41387 10.2945 5.49557 10.4071 5.63634L10.4468 5.68942C10.4796 5.73627 10.508 5.78601 10.5317 5.83804L10.5423 5.86389L10.5599 5.91097C10.6148 6.03789 10.7316 6.13851 10.8562 6.1579C10.87 6.17036 10.9227 6.18143 10.9753 6.17913C11.0365 6.17707 11.0968 6.16293 11.1525 6.1375C11.2083 6.11207 11.2585 6.07587 11.3002 6.03097C11.4068 5.91097 11.5984 5.78173 11.6944 5.78173C11.7202 5.78173 11.7285 5.78588 11.7641 5.83342C11.8107 5.8985 11.8268 5.97974 11.8116 6.09743L11.7978 6.1722C11.7318 6.45144 11.5074 6.78422 11.2757 6.99884L11.255 7.01638L11.2379 7.01223L8.79629 7.00854L8.75013 7.01315L8.73536 7.01638L8.71367 6.99792C8.46166 6.76438 8.2175 6.38867 8.17781 6.09328C8.15796 5.97697 8.17273 5.90173 8.22027 5.84081C8.26412 5.78681 8.27566 5.78173 8.29643 5.78173C8.3915 5.78173 8.58166 5.91004 8.68413 6.02405L8.72198 6.06374C8.7666 6.10459 8.81922 6.13574 8.8765 6.1552C8.93378 6.17467 8.99448 6.18203 9.05476 6.17682L9.10968 6.16713C9.1855 6.15105 9.25597 6.11592 9.31444 6.06504C9.37291 6.01416 9.41745 5.94922 9.44384 5.87635C9.46692 5.81312 9.51077 5.72773 9.58231 5.63911ZM8.48336 11.7856C8.48336 11.5908 8.63059 11.4385 8.81752 11.4385H9.66539V11.067H8.81706C8.63013 11.067 8.4829 10.9142 8.4829 10.719C8.4829 10.5242 8.63013 10.3719 8.81706 10.3719H9.58508L8.73583 9.47002C8.67121 9.40217 8.6389 9.32093 8.6389 9.22862C8.63781 9.18215 8.64654 9.13597 8.66452 9.09311C8.68249 9.05024 8.70931 9.01165 8.74321 8.97985C8.7726 8.94837 8.80821 8.92334 8.84777 8.90634C8.88734 8.88933 8.93 8.88073 8.97306 8.88107C9.01949 8.88052 9.06544 8.89039 9.10754 8.90996C9.14964 8.92953 9.18681 8.9583 9.2163 8.99415L9.99909 9.81803L10.7828 8.97938C10.813 8.94522 10.8503 8.918 10.892 8.89958C10.9337 8.88117 10.9789 8.872 11.0245 8.8727C11.0701 8.8734 11.115 8.88396 11.1562 8.90365C11.1973 8.92334 11.2337 8.95169 11.2628 8.98677C11.3237 9.05231 11.3567 9.13895 11.3548 9.22837C11.3529 9.31779 11.3163 9.40296 11.2527 9.46586L10.4126 10.3719H11.1816C11.369 10.3719 11.5158 10.5242 11.5158 10.719C11.5158 10.9147 11.369 11.067 11.1816 11.067H10.3337V11.4385H11.1816C11.369 11.4385 11.5158 11.5908 11.5158 11.7856C11.5158 11.9809 11.369 12.1341 11.1816 12.1341H10.3337V12.6806C10.3337 12.8721 10.1842 13.0281 9.99956 13.0281C9.81217 13.0281 9.66585 12.8758 9.66585 12.6806V12.1341H8.81752C8.63059 12.1341 8.48336 11.9809 8.48336 11.7856Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>使用金币<span>余额: {{user.gold_total}}金币</span></h1>
        </div>  
        <div class="buy_close">
          <svg class="check" v-show="use_gold" @click="use_gold_fn" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
            <path d="M6.32288 11.2668L9.02721 13.9711C9.41774 14.3616 10.0509 14.3616 10.4414 13.9711L15.884 8.52856" stroke="#FF443D" stroke-width="1.25" stroke-linecap="round"/>
          </svg>
          <svg class="check" v-show="!use_gold" @click="use_gold_fn" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
          </svg>
        </div>
      </div>

      <!-- wap暂无优惠券 -->
      <div class="buy_wrap buy_wrap_h" v-show='!is_wap &&
          !(is_order_buy)'>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#4DABE9"/>
          <path d="M13.4671 5.9563C14.1933 5.9563 14.7822 6.52531 14.7822 7.22718V8.84467C14.7822 8.93659 14.7444 9.02475 14.6771 9.08975C14.6098 9.15475 14.5186 9.19127 14.4235 9.19127C14.2015 9.19127 13.9887 9.27648 13.8317 9.42814C13.6748 9.57981 13.5866 9.78552 13.5866 10C13.5866 10.2145 13.6748 10.4202 13.8317 10.5719C13.9887 10.7235 14.2015 10.8088 14.4235 10.8088C14.5186 10.8088 14.6098 10.8453 14.6771 10.9103C14.7444 10.9753 14.7822 11.0634 14.7822 11.1554V12.7728C14.7822 13.4747 14.1933 14.0437 13.4671 14.0437H6.53294C5.80665 14.0437 5.21785 13.4747 5.21785 12.7728V11.1554C5.21785 11.0634 5.25564 10.9753 5.3229 10.9103C5.39016 10.8453 5.48139 10.8088 5.57651 10.8088C5.79846 10.8088 6.01133 10.7235 6.16827 10.5719C6.32522 10.4202 6.41339 10.2145 6.41339 10C6.41339 9.78552 6.32522 9.57981 6.16827 9.42814C6.01133 9.27648 5.79846 9.19127 5.57651 9.19127C5.48139 9.19127 5.39016 9.15475 5.3229 9.08975C5.25564 9.02475 5.21785 8.93659 5.21785 8.84467V7.22718C5.21785 6.52531 5.80665 5.9563 6.53294 5.9563H13.4671ZM9.06497 8.02864C9.00227 7.96462 8.91667 7.92609 8.82561 7.92089C8.73455 7.9157 8.64486 7.94423 8.5748 8.00068L8.55782 8.01524C8.49157 8.07584 8.4517 8.15855 8.44633 8.24655C8.44095 8.33455 8.47048 8.42123 8.52889 8.48893L9.33385 9.42234H8.80446L8.78342 9.42292C8.69209 9.4281 8.60627 9.46682 8.54351 9.53114C8.48075 9.59547 8.4458 9.68053 8.4458 9.76894L8.4464 9.78928C8.45177 9.87753 8.49183 9.96047 8.55839 10.0211C8.62495 10.0818 8.71298 10.1156 8.80446 10.1155H9.70112V10.5777H8.80446L8.78342 10.5783C8.69209 10.5834 8.60627 10.6222 8.54351 10.6865C8.48075 10.7508 8.4458 10.8359 8.4458 10.9243L8.4464 10.9446C8.45177 11.0329 8.49183 11.1158 8.55839 11.1765C8.62495 11.2371 8.71298 11.2709 8.80446 11.2709H9.70112V11.733L9.70171 11.7534C9.70708 11.8416 9.74714 11.9246 9.8137 11.9852C9.88026 12.0459 9.96829 12.0796 10.0598 12.0796L10.0808 12.0791C10.1721 12.0739 10.258 12.0352 10.3207 11.9708C10.3835 11.9065 10.4184 11.8214 10.4184 11.733V11.2709H11.1955L11.2166 11.2703C11.3079 11.2651 11.3937 11.2264 11.4565 11.1621C11.5193 11.0978 11.5542 11.0127 11.5542 10.9243L11.5536 10.904C11.5482 10.8157 11.5082 10.7328 11.4416 10.6721C11.375 10.6115 11.287 10.5777 11.1955 10.5777H10.4184V10.1155H11.1955L11.2166 10.115C11.3079 10.1098 11.3937 10.0711 11.4565 10.0067C11.5193 9.94242 11.5542 9.85735 11.5542 9.76894L11.5536 9.74861C11.5482 9.66035 11.5082 9.57741 11.4416 9.51676C11.375 9.45611 11.287 9.42233 11.1955 9.42234H10.6659L11.4711 8.48882L11.4851 8.4716C11.5407 8.39896 11.5648 8.30821 11.5521 8.21868C11.5395 8.12915 11.4912 8.04793 11.4175 7.99231C11.3438 7.93669 11.2506 7.91108 11.1577 7.92093C11.0647 7.93078 10.9794 7.97532 10.92 8.04505L10 9.11201L9.08003 8.04505L9.06497 8.02864Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>优惠券</h1>
        </div>  
        <div class="buy_close" @click="buy_coupon">
          <h1 v-if="coupon_sub_amount > 0" class="c13 red">-{{coupon_sub_amount}}</h1>
          <h1 v-else :class="['c13',coupons.length ? 'red' : 'c63']">{{coupons.length== 0 ? '无可用' : coupons.length+'张可用'}}</h1>
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="25" viewBox="0 0 13 25" fill="none">
            <path d="M3.45001 6.37142L9.80111 12.1533C9.93548 12.2756 9.93754 12.4864 9.80558 12.6113L3.45001 18.6286" stroke="#939393" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- wap暂无发票 -->
      <div class="buy_wrap buy_wrap_no3" v-if="!is_wap && is_invoice_switch > 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" fill="#F06460"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2098 14.2273L14.239 14.2478V5.9393C14.239 5.7793 14.1757 5.62582 14.0628 5.51241C13.95 5.39901 13.7968 5.33491 13.6368 5.33414H6.36321C6.20321 5.33491 6.05004 5.39901 5.93718 5.51241C5.82433 5.62582 5.76097 5.7793 5.76097 5.9393V14.1542C5.92954 14.066 6.11887 14.0251 6.30883 14.0359C6.49879 14.0467 6.68226 14.1089 6.83973 14.2156L7.49167 14.6659L8.12898 14.2156C8.30782 14.0894 8.52108 14.021 8.73999 14.0198C8.95682 14.0198 9.16828 14.0873 9.34515 14.2127L9.99123 14.6659L10.6695 14.2039C10.8492 14.0806 11.0629 14.0164 11.2808 14.02C11.4988 14.0237 11.7101 14.0951 11.8856 14.2244L12.4703 14.6425L12.941 14.2653C13.1202 14.1231 13.3405 14.0426 13.5691 14.0357C13.7977 14.0289 14.0225 14.0961 14.2098 14.2273ZM9.60945 10.9682V12.1399H10.3838V10.9682H11.5959V10.5575H10.3838V10.0861H11.5959V9.67539H10.5656L11.7709 7.31864H10.9898L10.4579 8.52395C10.3782 8.70139 10.3024 8.87884 10.2253 9.05942C10.159 9.21463 10.0918 9.37215 10.0202 9.53399H9.98653C9.90827 9.35255 9.83376 9.17299 9.76003 8.99531C9.69421 8.83669 9.62901 8.67957 9.56232 8.52395L9.0371 7.31864H8.22907L9.42765 9.67539H8.40414V10.0861H9.60945V10.5575H8.40414V10.9682H9.60945Z" fill="white"/>
        </svg>
        <div class="buy_content">
          <h1>开具发票</h1>
          <p>已开票的订单可前往“账户钱包 - 发票”中查看</p>
        </div>  
        <div class="buy_close">
          <svg class="check" v-show="use_invoice" @click="use_invoice = !use_invoice" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
            <path d="M6.32288 11.2668L9.02721 13.9711C9.41774 14.3616 10.0509 14.3616 10.4414 13.9711L15.884 8.52856" stroke="#FF443D" stroke-width="1.25" stroke-linecap="round"/>
          </svg>
          <svg class="check" v-show="!use_invoice" @click="use_invoice = !use_invoice" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
          </svg>
        </div>
      </div>

      <div class="invoice_box" v-show="use_invoice">
        <div class="invoice_i">
          <h1>抬头类型</h1>
          <div class="invoice_c">
            <div class="invoice_c1 invoice_c2" @click="invoice_kind = 0;">
              <svg v-show="invoice_kind != 0" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                <rect x="2.5" y="3" width="17" height="17" rx="8.5" stroke="#DCDCDC"/>
              </svg>
              <svg v-show="invoice_kind == 0" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                <rect x="2" y="2.5" width="18" height="18" rx="9" fill="#EC5F2A"/>
                <path d="M6.57379 11.5023L9.09908 14.0276C9.48961 14.4181 10.1228 14.4181 10.5133 14.0276L15.6331 8.90781" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
              <span>企业</span>
            </div>
            <div class="invoice_c1 " @click="invoice_kind = 1;">
              <svg v-show="invoice_kind != 1" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                <rect x="2.5" y="3" width="17" height="17" rx="8.5" stroke="#DCDCDC"/>
              </svg>
              <svg v-show="invoice_kind == 1" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                <rect x="2" y="2.5" width="18" height="18" rx="9" fill="#EC5F2A"/>
                <path d="M6.57379 11.5023L9.09908 14.0276C9.48961 14.4181 10.1228 14.4181 10.5133 14.0276L15.6331 8.90781" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
              <span>个人/非企业单位</span>
            </div>
          </div>
        </div>
        <div class="invoice_i">
          <h1>发票抬头</h1>
          <input placeholder="填写发票抬头" v-model="tax_title" />
        </div>
        <div class="invoice_i" v-show="invoice_kind == 0">
          <h1>税号</h1>
          <input placeholder="填写纳税人识别号" v-model="tax_num" />
        </div>
        <div class="invoice_i">
          <h1>电子邮件</h1>
          <input placeholder="用于向您发送电子发票" v-model="email" />
        </div>
        <div class="invoice_i">
          <p>提示：开具的发票将在服务期结束后自动发送至您填写的邮箱，发票内容为“咨询费”，历史开票前往“账户钱包 - 发票”中查看。</p>
        </div>
      </div>


      <!-- 购买弹幕滚动 -->

      <div class="discussion-board-box" v-if="newsList && newsList.length > 0">
        <discussion-board :newsList="newsList" :vip_open_comment="vip_open_comment"></discussion-board>
      </div>
      
      

      <!-- 联系客服  投诉电话-->
      <div class="contact">
        <div class="contact_o">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M11.0601 16.3046C11.144 16.3046 11.2297 16.2998 11.3159 16.2897C12.1398 16.1945 12.8399 15.636 13.0987 14.8674C13.108 14.8395 13.1065 14.8091 13.0943 14.7823C13.0822 14.7555 13.0604 14.7343 13.0332 14.7229C13.0058 14.7107 12.9749 14.7088 12.9462 14.7175C12.9174 14.7262 12.8928 14.745 12.8768 14.7705C12.8738 14.7764 12.5461 15.288 11.2707 15.4545C11.0804 15.4795 10.8948 15.4926 10.7187 15.4926C9.82524 15.4926 9.4267 15.166 9.42313 15.1631C9.40093 15.1442 9.37285 15.1338 9.34374 15.1334C9.31463 15.1331 9.28633 15.1429 9.26371 15.1613C9.2413 15.1792 9.2263 15.2048 9.22158 15.2331C9.21686 15.2614 9.22275 15.2905 9.23813 15.3147C9.43538 15.6184 9.70535 15.868 10.0235 16.0409C10.3417 16.2137 10.698 16.3044 11.0601 16.3046ZM17.9169 8.65188C17.9056 8.65188 17.8955 8.65425 17.8848 8.65425C17.1377 5.5218 14.2824 3.18405 10.8597 3.18405C7.34295 3.18405 4.42285 5.65028 3.77507 8.91242C3.14572 9.02187 2.66687 9.55723 2.66687 10.205V12.7985C2.66687 13.5243 3.26885 14.1143 4.01122 14.1143C4.43059 14.1143 4.80058 13.9222 5.04685 13.6284C5.64169 15.1512 6.85221 16.3789 8.38393 17.0267C8.4033 16.9896 8.426 16.9544 8.45174 16.9214C8.47554 16.8911 8.5029 16.8661 8.5261 16.8661C8.5499 16.8661 8.5719 16.8744 8.59094 16.8875C8.23641 16.6317 6.95511 15.3177 6.67792 13.4838C6.55657 12.6772 7.18056 11.8849 7.90806 11.7534C9.07514 11.5428 10.2363 11.3031 11.4034 11.0967C12.1451 10.9658 12.6525 10.5714 12.9619 9.91533C13.035 9.76186 13.1403 9.45135 13.1879 9.00462C13.1938 8.97143 13.2113 8.9414 13.2372 8.91985C13.2631 8.89829 13.2958 8.8866 13.3295 8.88684C13.3771 8.88684 13.4187 8.91063 13.4455 8.94454L13.4776 8.9255C13.9374 9.5721 14.8499 11.0045 14.9808 12.5148C15.1313 14.241 15.0474 15.4236 13.6828 16.6335L13.6769 16.6383C13.6577 16.6583 13.6471 16.6849 13.6471 16.7126C13.6471 16.7495 13.6674 16.7816 13.6971 16.8007C13.7084 16.8054 13.7197 16.8114 13.731 16.8155C13.7399 16.8173 13.7488 16.8203 13.7578 16.8203C13.7673 16.8203 13.7756 16.8173 13.7833 16.8155C13.803 16.8054 13.8214 16.7941 13.8405 16.7846C15.2205 16.0482 16.2793 14.8186 16.7683 13.3399C16.9664 13.6248 17.2763 13.8294 17.6368 13.9014C17.0592 16.4455 14.7155 18.0385 11.812 18.28C11.6383 17.8619 11.21 17.565 10.7068 17.565C10.0495 17.565 9.51711 18.0689 9.51711 18.6899C9.51711 19.3109 10.0495 19.8142 10.7068 19.8142C11.2362 19.8142 11.68 19.4846 11.834 19.0319C15.1949 18.7678 17.889 16.8328 18.4511 13.827C18.9484 13.626 19.297 13.1543 19.297 12.6028V9.97957C19.297 9.24613 18.6789 8.65128 17.9169 8.65128V8.65188ZM16.6773 9.40554C15.8005 7.10587 13.5293 5.4635 10.8573 5.4635C8.19656 5.4635 5.93317 7.09219 5.04863 9.37699C5.00461 9.32465 4.95286 9.28003 4.9023 9.23482C5.40316 6.45095 7.87712 4.33389 10.8603 4.33389C13.8292 4.33389 16.2954 6.43012 16.8129 9.19437C16.761 9.26022 16.7156 9.33094 16.6773 9.40554ZM8.38691 17.0279H8.38631C8.38274 17.035 8.38274 17.0362 8.38691 17.0279Z" fill="#5CC0E7"/>
          </svg>
          <span @click="navigatAppTo('custom_service', '')">联系客服</span>
        </div>
        <div class="contact_o contact_o2" @click="show_phone=true;">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M13.334 3.73011C13.293 3.72223 13.2536 3.71435 13.2126 3.71435C12.8565 3.69859 12.5429 3.94916 12.4688 4.29586C12.4279 4.48969 12.4688 4.68352 12.5744 4.84584C12.68 5.00815 12.8486 5.12004 13.0346 5.16102C14.5695 5.47619 15.8853 6.37287 16.7505 7.68085C17.6141 8.98884 17.9135 10.5568 17.5983 12.0902C17.5574 12.284 17.5983 12.4778 17.7039 12.6402C17.8095 12.8009 17.9781 12.9144 18.1641 12.9553C18.205 12.9632 18.2444 12.9711 18.2854 12.9711C18.4383 12.979 18.5848 12.9396 18.7141 12.8498C18.8764 12.7442 18.9883 12.5756 19.0292 12.3896C19.844 8.4294 17.2926 4.54484 13.334 3.73011ZM14.5868 14.6731C14.6278 14.6967 15.5891 15.3192 16.3313 16.0787C16.6055 16.3703 17.0751 16.8462 17.0657 17.4041C17.0578 17.7838 16.8388 18.1636 16.4117 18.5671C16.3061 18.6726 15.3448 19.5693 13.8036 19.5693C13.3828 19.5693 12.9479 19.5047 12.5193 19.3676C12.067 19.2305 11.6068 19.0209 11.1467 18.7373C9.34542 17.6798 7.96495 16.3057 6.63963 14.3027C4.37666 10.8531 4.31205 7.90463 4.32151 7.34834C4.32151 4.77965 6.46156 3.77109 6.70424 3.6655C7.04306 3.51106 7.33302 3.43069 7.59934 3.43069C7.72857 3.43069 7.84991 3.44645 7.97125 3.48743C8.20606 3.55992 8.537 3.74587 8.75447 4.22179C9.05389 4.8679 9.33597 5.7961 9.5298 6.76527C9.73152 7.77541 9.16577 8.05749 8.62525 8.3317H8.60161C8.60161 8.3317 7.63244 8.73512 7.46224 8.80761C7.29205 8.8801 7.21168 9.06606 7.26841 9.23625C7.66396 10.415 8.25334 11.6426 8.98927 12.7741C9.71576 13.8883 10.573 14.922 11.4776 15.7541C11.5422 15.8108 11.6226 15.8424 11.7124 15.8424H11.7439C11.8416 15.8345 11.9299 15.7856 11.9866 15.7131C12.1316 15.5272 12.3585 15.253 12.6012 15.0261C13.0535 14.5974 13.4569 14.3878 13.8446 14.3878C13.9502 14.3878 14.0542 14.4036 14.1598 14.4367C14.2543 14.4713 14.4166 14.5517 14.5868 14.6731ZM11.5328 9.70587C11.3436 9.66647 11.1766 9.55301 11.0726 9.39069C10.967 9.22995 10.9276 9.03612 10.967 8.84071C11.0395 8.49401 11.3547 8.24345 11.7108 8.2592C11.7518 8.2592 11.7912 8.26708 11.8322 8.27496C13.5199 8.62166 14.6105 10.2858 14.2638 11.9736C14.2228 12.1595 14.1109 12.3281 13.9486 12.4337C13.8194 12.5141 13.6744 12.5551 13.5199 12.5551C13.479 12.5551 13.4396 12.5472 13.3986 12.5393C13.2095 12.4999 13.0424 12.3864 12.9384 12.2241C12.8329 12.0634 12.7935 11.868 12.8329 11.6741C12.9211 11.2376 12.8407 10.7853 12.5902 10.4134C12.3412 10.0541 11.9693 9.79569 11.5328 9.70587ZM12.2844 7.42083C11.8889 7.34046 11.6383 6.9528 11.7187 6.56513C11.7912 6.21843 12.1064 5.96787 12.4625 5.98363C12.5035 5.98363 12.5429 5.99151 12.5839 5.99939C13.9486 6.28147 15.1273 7.08202 15.9027 8.2529C16.6701 9.42378 16.9443 10.8216 16.6623 12.1863C16.6229 12.3754 16.5094 12.5425 16.3471 12.6465C16.2179 12.7268 16.0729 12.7757 15.9184 12.7678C15.8775 12.7678 15.8381 12.7599 15.7971 12.7521C15.4015 12.6717 15.151 12.284 15.2314 11.8963C15.4331 10.9114 15.2392 9.90128 14.6814 9.05345C14.1251 8.20405 13.2773 7.62255 12.2844 7.42083Z" fill="#5CC0E7"/>
          </svg>
          <span>投诉电话</span>
        </div>
      </div>

      <!-- 我已阅读并同意 协议 -->
      <div class="tip_w">
        <div class="tip_o">
          <svg class="check" v-show="use_tip" @click="use_tip = !use_tip" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
            <path d="M6.32288 11.2668L9.02721 13.9711C9.41774 14.3616 10.0509 14.3616 10.4414 13.9711L15.884 8.52856" stroke="#FF443D" stroke-width="1.25" stroke-linecap="round"/>
          </svg>
          <svg class="check" v-show="!use_tip" @click="use_tip = !use_tip" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <rect x="2.5" y="3" width="17" height="17" rx="3.1" stroke="#DCDCDC"/>
          </svg>
          <p>
            我已阅读并同意
            <span v-if="livers.agreement_intro" @click="goPage('agreement_detail',{
              url:`/up/app/agreement_detail?kind=agreement&id=${livers.agreement_id}&month_price=${livers.product_price}&name=金融信息产品购买协议`
            })">{{ livers.agreement_intro }}</span>
            <span style="color: #636363;" v-if="livers.agreement_intro">、</span>
            <span v-if="livers.user_intro && is_wap"  class="wap_img">{{livers.user_intro}}
              <img @load="$previewRefresh" 
                :src="livers.user_image" 
                :preview="Math.random().toString(36).slice(-4)"/>
            </span>
            <span v-if="livers.user_intro && !is_wap" @click="srBrowserMedia(livers.user_image)">{{livers.user_intro}}</span>
            <span  style="color: #636363;" v-if="livers.user_intro">和</span>
            <span v-if="livers.riskDisclosure" @click="goPage('agreement_detail',{
              url:`/up/app/agreement_detail?kind=warning&id=${livers.agreement_id}&month_price=${livers.product_price}&name=风险揭示书`
            })">{{livers.riskDisclosure}}</span>
          </p>
        </div>
        <div class="tip_o">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M11.1208 5.14898L7.69552 7.34879H5.98674C5.03722 7.34879 4.26768 8.1089 4.26768 9.061V12.4923C4.26768 13.4383 5.02781 14.2045 5.98674 14.2045H7.69552L11.1208 16.4026C11.605 16.6125 11.9803 16.388 11.9803 15.9115V5.64C11.9803 5.16268 11.5955 4.94416 11.1208 5.14898ZM14.007 7.91352C13.8459 7.74041 13.5742 7.73098 13.402 7.89295C13.2289 8.05492 13.2203 8.32572 13.3814 8.49882C13.4611 8.58451 13.5974 8.77391 13.7379 9.06013C13.9779 9.5486 14.1227 10.1219 14.1227 10.7766C14.1227 11.4314 13.9779 12.0055 13.7379 12.4931C13.5974 12.7793 13.4611 12.9687 13.3814 13.0544C13.2195 13.2275 13.2289 13.4983 13.402 13.6603C13.5751 13.8223 13.8459 13.8128 14.0079 13.6397C14.1424 13.4958 14.3275 13.2387 14.5075 12.871C14.8032 12.2694 14.9797 11.5685 14.9797 10.7758C14.9797 9.98309 14.8032 9.28209 14.5075 8.68051C14.3267 8.31457 14.1416 8.05662 14.007 7.91352ZM16.6344 7.38306C16.2882 6.7969 15.9386 6.3907 15.6935 6.17218C15.517 6.01452 15.2462 6.02994 15.0885 6.20732C14.9308 6.38471 14.9462 6.65465 15.1236 6.81232C15.1639 6.8483 15.2445 6.92887 15.3524 7.05398C15.5375 7.26821 15.7226 7.52359 15.8966 7.81839C16.3945 8.66335 16.6936 9.65141 16.6936 10.7766C16.6936 11.9018 16.3945 12.8899 15.8957 13.7357C15.7218 14.0305 15.5358 14.2859 15.3516 14.5001C15.2436 14.6252 15.163 14.7058 15.1228 14.7417C14.9462 14.8994 14.9308 15.1702 15.0876 15.3468C15.2445 15.5233 15.5161 15.5387 15.6926 15.3819C15.9377 15.1634 16.2874 14.758 16.6336 14.171C17.2061 13.2001 17.5497 12.0646 17.5497 10.7766C17.5505 9.48948 17.2069 8.354 16.6344 7.38306Z" fill="#DD5456"/>
          </svg>
          <p>风险提示：会员区服务内容，仅做为投资参考，并不保证收益。投资有风险，入市须谨慎。</p>
        </div>
      </div>


      <!-- 购买 支付 -->
      <div class="bottom" v-if="!is_wap" @click="goPage('invite_members',{
        l_id:l_id,
      })"></div>

      <div class="buy_box">
        <div class="buy_box_l">
          ¥
          <span>{{ price }}</span>
        </div>
        <div class="buy_box_r" @click="pay"
          :class='[
            (is_order_buy || pay_success) ? "buy_box_b" :  ""]'
          >{{txt}}</div>
      </div>




    </div>

    <!-- 投诉电话 弹窗 -->
    <div class="show_phone_wrap" v-show="show_phone">
      <div class="show_phone">
        <h1>提示</h1>
        <p>投诉电话：{{phone}}</p>
        <h2 @click="show_phone = false;">确定</h2>
      </div>
    </div>

    <!-- 未同意协议 弹窗 -->
    <div class="show_phone_wrap" v-show="show_agreement">
      <div class="show_agreement">
        <h1>请认真阅读以下协议</h1>
        <p>
          <span  v-if="livers.agreement_intro" @click="goPage('agreement_detail',{
            url:`/up/app/agreement_detail?kind=agreement&id=${livers.agreement_id}&month_price=${livers.product_price}`
          })">{{ livers.agreement_intro }}
          
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 1.33334L10.7745 7.5007C10.9178 7.63118 10.92 7.85598 10.7793 7.98924L4 14.4076" stroke="#D7D7D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </span>
          <span  v-if="!is_wap && livers.user_intro" @click="srBrowserMedia(livers.user_image)">
            {{livers.user_intro}}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 1.33334L10.7745 7.5007C10.9178 7.63118 10.92 7.85598 10.7793 7.98924L4 14.4076" stroke="#D7D7D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="wap_img" v-if="is_wap && livers.user_intro">
            {{livers.user_intro}}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 1.33334L10.7745 7.5007C10.9178 7.63118 10.92 7.85598 10.7793 7.98924L4 14.4076" stroke="#D7D7D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <img @load="$previewRefresh" 
                :src="livers.user_image" 
                :preview="Math.random().toString(36).slice(-4)"/>
          </span>
          <span v-if="livers.riskDisclosure" @click="goPage('agreement_detail',{
            url:`/up/app/agreement_detail?kind=warning&id=${livers.agreement_id}&month_price=${livers.product_price}`
          })">{{livers.riskDisclosure}}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 1.33334L10.7745 7.5007C10.9178 7.63118 10.92 7.85598 10.7793 7.98924L4 14.4076" stroke="#D7D7D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </span>
        </p>
        <p class="flex">
          <span @click="show_agreement = false;">不同意</span>
          <span @click="agree_to">同意</span>
        </p>
      </div>
    </div>

    <!-- 选择会员分组 弹窗  -->
    <div class="show_phone_wrap" v-show="show_group">
      <div class="show_group_class_wrap">
        <h1>选择会员分组</h1>
        <div class="show_group_class" v-for="(item,i) in groups" :key="item.id">
          <div class="show_group_lef">
            <h1>{{ item.g_name }} 
              
              <span 
              :class="[
                item.g_status=='yes' && item.can_order=='yes' ? 'can_order' : '',
                item.g_status=='yes' && item.can_order=='no' ? 'can_order_not' : '',
              ]" 
              v-if="item.places_tips">{{ item.places_tips }}{{ item.g_status=='yes' && item.can_order=='yes' ? '，可预约' : '' }}</span> </h1>
            <h2 v-if="item.g_intro" @click="show_group_detail = true;show_group_detail_i = i;">
              分组说明
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
                <path d="M1 0.5L5.04475 4.18225C5.18671 4.31148 5.18888 4.53411 5.04948 4.66609L1 8.5" stroke="#D7D7D7" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </h2>
          </div>
          <div class="show_group_rig">
            <svg @click="choose_group(item,i); "
            :class="[
                item.g_status=='yes' && item.can_order=='yes' ? 'can_order' : '',
                item.g_status=='yes' && item.can_order=='no' ? 'can_order_not' : '',
              ]"
              v-if="current_group.id != item.id" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="0.5" y="0.5" width="19" height="19" rx="4.5" stroke="#DCDCDC"/>
            </svg>
            <svg  v-if="current_group.id == item.id" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect width="20" height="20" rx="5" fill="#FF443D"/>
              <path d="M5.4375 9.58523L8.5346 12.6823C8.65664 12.8044 8.85451 12.8044 8.97654 12.6823L14.5622 7.09668" stroke="white" stroke-width="1.875" stroke-linecap="round"/>
            </svg>

          </div>
        </div>
        <p class="flex">
          <span class="one" @click="show_group = false;">取消</span>
        </p>
      </div>
    </div>

    <!-- 选择会员分组 的 会员分组信息 弹窗  -->
    <div class="show_phone_wrap" v-show="show_group_detail">
      <div class="show_agreement">
        <h1>{{ show_group_detail_i > 0 && groups[show_group_detail_i].g_name }}分组说明</h1>
        <div class="show_group_detail">
          {{ show_group_detail_i > 0 && groups[show_group_detail_i].g_intro }}
        </div>
        <p class="flex">
          <span @click="show_group_detail = false;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8687 10C18.8687 14.76 15.01 18.6187 10.25 18.6187C5.49006 18.6187 1.63135 14.76 1.63135 10C1.63135 5.24003 5.49006 1.38132 10.25 1.38132C15.01 1.38132 18.8687 5.24003 18.8687 10ZM19.8687 10C19.8687 15.3123 15.5623 19.6187 10.25 19.6187C4.93778 19.6187 0.631348 15.3123 0.631348 10C0.631348 4.68775 4.93778 0.381317 10.25 0.381317C15.5623 0.381317 19.8687 4.68775 19.8687 10ZM10.5296 13.556L7.39193 10.4183H15.2812V9.41828H7.39193L10.5296 6.28056L9.82254 5.57345L5.83127 9.56472L5.47771 9.91828L5.83127 10.2718L9.82254 14.2631L10.5296 13.556Z" fill="#636363"/>
            </svg>
            返回

            
          </span>
          <span @click="show_group_detail = false;groups_num = show_group_detail_i">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.14282 2.83594C3.14282 1.45522 4.26211 0.335938 5.64282 0.335938H17.4835C18.8642 0.335938 19.9835 1.45523 19.9835 2.83594V14.6766C19.9835 16.0573 18.8642 17.1766 17.4835 17.1766H17.0692V16.1766H17.4835C18.3119 16.1766 18.9835 15.505 18.9835 14.6766V2.83594C18.9835 2.00751 18.3119 1.33594 17.4835 1.33594H5.64282C4.81439 1.33594 4.14282 2.00751 4.14282 2.83594V3.26243H3.14282V2.83594ZM14.357 4.82343H2.51636C1.96407 4.82343 1.51636 5.27114 1.51636 5.82343V17.6641C1.51636 18.2164 1.96407 18.6641 2.51636 18.6641H14.357C14.9093 18.6641 15.357 18.2164 15.357 17.6641V5.82343C15.357 5.27114 14.9093 4.82343 14.357 4.82343ZM2.51636 3.82343C1.41179 3.82343 0.516357 4.71886 0.516357 5.82343V17.6641C0.516357 18.7687 1.41179 19.6641 2.51636 19.6641H14.357C15.4616 19.6641 16.357 18.7687 16.357 17.6641V5.82343C16.357 4.71886 15.4616 3.82343 14.357 3.82343H2.51636ZM7.91855 14.8193L13.6281 9.10981L12.921 8.4027L7.56499 13.7587L4.63211 10.8259L3.92502 11.533L7.21145 14.8193L7.565 15.1729L7.91855 14.8193Z" fill="#FF443D"/>
            </svg>
            选择该分组</span>
        </p>
      </div>
    </div>

    <!-- 使用金币 弹窗 -->
    <div class="show_phone_wrap" v-show="show_gold_tip">
      
      <div class="show_gold_tip_class">
        <div class="show_gold_tip_class_close" @click="show_gold_tip = false"></div>
        <div class="show_gold_tip_wrap">
          <h1>温馨提示</h1>
          <h2>{{ gold_tip.show_title }}</h2>
          <h3>{{ gold_tip.title_intro }}</h3>
          <p v-html="gold_tip.message_info.replace('\r\n','<br>')"></p>
          <div class="xjzf" @click="show_gold_tip = false;pay()">现金支付</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
var pingpp = require("pingpp-js");
import "@/utils/flexible";
import discussionBoard from "@/components/BulletScreen/index.vue";
import goldApi from '@/api/gold/detail.js'
import {source,getQueryVariable} from "@/utils/urlQuery";
export default {
    components:{
        discussionBoard,
    },
    data(){
        return{
          vip_open_comment:1,//是否显示购买弹幕 固定打开
          newsList:[],//购买弹幕列表
          l_id:this.$route.query.l_id,//购买的会员老师l_id
          livers:{},//购买的会员老师个人信息
          groups:[],//购买的会员老师分组信息
          user:{},//用户金币信息
          user_survey:{},//风险评估信息
          
          max_num:20,//会员服务 最大字数
          products:[],//购买的会员老师产品信息

          products_num:0,//选择产品数组下标
          groups_num:0,//选择分组数组下标


          use_gold:false,//是否用金币
          use_invoice:false,//是否开发票 wap没用到
          use_tip:false,//是否同意协议

          price:0,//最终价格
          

          show_vips:true,//是否显示服务期限

          show_phone:false,//投诉电话 弹窗
          phone:'',//投诉电话 
          

          show_agreement:false,//未同意协议的弹窗
          show_group:false,//会员分组的弹窗
          show_group_detail:false,//会员分组说明的弹窗
          show_gold_tip:false,//金币使用提示弹窗
          gold_tip:{
            "show_title": "",
            "show_value": "",
            "title_intro": "",
            "message_info": ""
          },//金币使用提示弹窗内容

          show_group_detail_i :-1,//会员分组详情弹窗 显示内容的分组下标

          txt:'支付',//支付按钮文字

          paying:false,//处于支付状态，防止重复点击 支付 暂时没有用到


          u_id:Number(getQueryVariable('u_id')) || 0,//wap页面会根据接口返回的值 重新赋值

          timer_await:null,//支付 暂时没有用到
          bindWeChatCheck:false,//是否通过微信绑定检测


          //以下 wap未用到  wap无优惠券 与 发票
          coupon_sub_amount:0,//优惠券减价格  
          is_invoice_switch:0,//是否开具发票
          invoice_kind:0,//开发票 公司 0 个人 1
          tax_title:'',//开发票相关
          email:'',//开发票相关
          tax_num:'',//开发票相关
          coupons:[],//优惠券
          //返现活动标识
          igp_invite_setting:localStorage.getItem('igp_invite_setting') == null ? 1 : localStorage.getItem('igp_invite_setting'),
          existing_parameter:{},
          vip_kind:getQueryVariable('kind') || '', // 待支付pre_order  续费renewal
          g_id:Number(getQueryVariable('g_id')) || 0,
          p_id:Number(getQueryVariable('p_id')) || 0,
          pre_user_gold_id:Number(getQueryVariable('pre_user_gold_id')) || 0,
          coupon_id:Number(getQueryVariable('coupon_id')) || 0,

        }
    },
    created() {
      console.log('get_uid',this.get_uid);
      //获取当前登录用户id
      this.u_id = this.get_uid ? this.get_uid : this.u_id;
      console.log(this.u_id,'this.u_id')
      //获取会员产品信息 购买弹幕信息
      setTimeout(() => {
        this.LiveBuyVip();
        this.getlist();   
      }, 10);      
      
    },
    computed:{
      is_wap(){
        //wap页面的标识
        return location.href.includes('/wap');
      },
      current_group(){
        //选择的当前分组
        if(this.groups_num >= 0){
          return this.groups[this.groups_num];
        }
        else{
          return {};
        }
      },
      current_product(){
        //当前选择的服务期限
        if(this.products_num >= 0){
          return this.products[this.products_num];
        }
        else{
          return {};
        }
      },
      is_order_buy(){
        //是否预约购买（Wap应该用不到
        if(this.current_group.g_status=="yes"  
          &&
          this.current_group.can_order=="yes"){
            return true;
        }
        else{
          return false;
        }
      },
      pay_success(){
        //wap没用到
        if(this.txt == '预约成功' || this.txt == '完成'){
          return true;
        }
        return false;
      },
      get_uid(){
        //获取当前登录用户的u_id
        if(this.$store && this.$store.state && this.$store.state.user.userId){
          return this.$store.state.user.userId;
        }
        else{
          return 0;
        }
      }
    },
    watch: {
      current_group(val, old) {
        //观察分组变化  分组如果变化 去掉使用金币
        if(val.id != old.id ){
          //去除优惠选取 两种方案吧
          this.use_gold = false;
        }
      },
      current_product(val, old){
        //观察服务期限变化 重新调用 使用金币 方法 
        if(val.id != old.id && !(val.g_status=='yes' && val.can_order == 'yes')){
          this.use_gold_fn_show();
        }
      }
    },
    mounted() {
        //mounted 里面都是给app用的 没有给wap用的

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }        
        window.srNativeCallH5Method = (data) => {
            let params = null;
            if(source == 'ios') {
                params = JSON.parse(data);
            } else {
                params = handleSpecialCharacters(data);
            }
            // if(params.method_name == 'vip_open_comment') {
            //   //接收app传过来的是否打开评论
            //   this.vip_open_comment = Number(params.params.is_open);
            // }
            // else 
            if(params.method_name == 'choose_vip_group_callback') {
              //接收app传过来的选择哪个会员分组（传数组下标即可）
              this.choose_vip_group_callback(params.params.groups_num)
            }
            else if(params.method_name == 'change_price') {
              //接收app传过来的最终价格
              this.change_price(params.params.price,params.params.coupon_sub_amount);
            } 
            else if(params.method_name == 'refresh_vip_buy_level'){
              this.LiveBuyVip('level');
            }
            else if(params.method_name == 'change_btn_word'){
              //接收app传过来的按钮文字
              this.change_txt(params.params.word);
            }
            else if(params.method_name == 'call_buy_pay'){
              //app调用h5支付方法
              if(params.params.price){
                this.change_price(params.params.price);
              }
              this.pay();
            }
        };
    },
    methods: {
      // 改变 支付 按钮的文字
      change_txt(txt){
        this.txt = txt;
      },
      //选择服务期限
      choose_product(i,vip_kind){
        let current_coupon = '';
        if(vip_kind == 'pre_order'){
          this.products.forEach((item,i)=>{
            if(item.id == this.p_id) {
              this.products_num = i;
            }
          })
          //优惠券相关wap都用不到
          if(this.coupon_id){
            current_coupon = this.coupons.filter(item => (item.id == this.coupon_id));
          }
        }
        else{
          this.products_num = i;
        }
        //改变当前支付价格
        this.change_price(this.products[i].sale_amount);
        // if(this.is_wap){
        //   return false;
        // }
        // this.$srH5CallNativeMethodApp('choose_vip_product',{
        //   product:JSON.stringify(this.products[this.products_num]),
        //   current_group:this.groups_num >-1 ? (JSON.stringify(this.groups[this.groups_num])) : '',//当前分组信息
        //   kind:this.vip_kind,
        //   livers:JSON.stringify(this.livers),
        //   current_coupon: current_coupon ? (JSON.stringify(current_coupon)) : '', 
        // })
      },
      //改变当前的支付 价格
      change_price(price,coupon_sub_amount){
        this.price = price;

        //app用 wap用不到
        if(coupon_sub_amount){
          this.coupon_sub_amount = coupon_sub_amount;
        }

        //有使用金币时 重新调用使用金币方法
        if(this.use_gold){
          this.use_gold_fn_show();
        }
        

        if(price == 0){
          this.change_txt('开通')
        }
        else{
          if(this.is_order_buy){
            this.change_txt('已满员 支付预约金')
          }
          else{
            this.change_txt('支付')
          }
          
        }
      },
      navigatAppTo(tag, id) {
        if(this.is_wap){
          //跳转小秘书客服
          if(tag == 'custom_service'){
            //this.$downapppop.open('查看');
            location.href = `/up/mes/108388`;
          }
          return false;
        }
        if(source == 'ios') {
          this.$srH5CallNativeMethodApp('igpJumpToNative',{
            jump_tag:tag, 
            jump_tag_id:id,      
          })
        }
        else{
          this.$igpJumpToNative(tag, id,true);
        }

      },
      //勾选 使用金币 需要调用后端接口
      async use_gold_fn_show(){
        //console.log('???')
        if(this.use_gold){
          let params = {
              l_id:this.l_id,
              u_id:this.u_id,
              user_id:this.u_id,
              balance_gold:this.user.gold_total,
              appversion:'11.8.0',
              g_id:this.current_group.id,
              is_appointment:this.can_order,
              p_id:this.current_product.id,
              term:this.current_product.term,
          }
          let res = await goldApi.user_platform_gold_limit(params);
          if(res.rslt == "succ" && res.message) {
            //succ + 返回 message：需要显示 使用金币 弹窗 
            this.show_gold_tip = true;
            this.gold_tip = res.message;
            this.price = res.message.show_value; //实际支付价格
          }
          else if(res.rslt == "succ" && !res.message){
            //succ + 没有 message：所有金币都可以使用 直接减金币即可 
            this.price = (this.price - this.user.gold_total) > 0 ? (this.price - this.user.gold_total) : 0;
          }
          else{
            //失败 弹窗
            alert(res.info);
          }
        }

        
      },
      //是否勾选 使用金币 
      use_gold_fn(){
        this.use_gold = !this.use_gold;
        if(this.is_wap){
          //勾选 使用金币 需要调用后端接口
          if(this.use_gold){
            this.use_gold_fn_show();
          }
          else{
            //未勾选 使用当前选择 服务期限 的价格
            this.price = this.current_product.sale_amount; 
          }
          
          return false;
        }
        // this.$srH5CallNativeMethodApp('use_vip_gold',{
        //   use_gold:Number(this.use_gold),
        //   user:JSON.stringify(this.user),
        //   price:this.price,
        //   product:JSON.stringify(this.products[this.products_num]),
        // })
      },
      //wap无优惠券
      buy_coupon(){
        this.$srH5CallNativeMethodApp('buy_coupon',{
          coupons:JSON.stringify(this.coupons),
          price:this.price,
          product:JSON.stringify(this.products[this.products_num]),
        })
      },
      //app查看图片
      srBrowserMedia(url){
        this.$srBrowserMedia(0,[{"type":"image","img_url": url}]);
      },
      // 跳转页面
      goPage(kind,data) {
        let params = {
          kind: kind,
        }
        if(data){
          params = {
              ...data,
              kind: kind,
          };
        }
        if(this.is_wap){
          if(kind == 'account'){
            //wap充值 跳转
            this.$downapppop.open('充值');
          }
          else if(data.url){
            //跳转wap页面
            location.href = data.url;
          }
          else if(kind == 'risk_assessment'){
            //跳转风险评估 ?kind=vip&l_id= 是为了 完成后能跳转回支付页面
            location.href = `/h5/new_survey/u_id/${this.u_id}/type/normal?kind=vip&l_id=${this.l_id}`;
          } 
          else{
            //wap无对应页面时  显示跳转app弹窗
            this.$downapppop.open('查看');
          }
          
        }
        else{
          //调用app方法
          this.$srH5CallNativeMethodApp('call_Native',params)
        }
        
      },
      //关闭邀请返现 wap无
      in_close(){
        //console.log('???')
        this.igp_invite_setting = 0;
        localStorage.setItem('igp_invite_setting',0)
      },
      //点击 选择会员分组 多个时弹窗，只有一个分组时会直接默认选择
      click_groups(){
        if(this.groups.length > 1){
          if(this.is_wap){
            this.show_group = true;
            return false;
          }
          this.$srH5CallNativeMethodApp('choose_vip_group',{
            groups:JSON.stringify(this.groups),
            coupons:JSON.stringify(this.coupons),
            is_renew:this.vip_kind == 'renewal' ? 1 : 0,
          })
        }
      },
      //选择会员分组 满员无法选择 
      choose_group(item,i){
        if(item.g_status=='yes' && item.can_order=='no'){
          alert("此分组已满员，请选择其他分组！");
        }
        else{
          this.choose_vip_group_callback(i);
        }
        

      },
      //选择会员分组 回调 
      choose_vip_group_callback(groups_num){
        this.groups_num = groups_num;
        //需要改变 服务期限数组
        this.products = this.groups[this.groups_num].price_per_term;
        this.show_group = false;
        //需要重新选择产品
        this.choose_product(0);
        
      },
      //获取 购买的弹幕数据 
      async getlist() {
          let params = {
              l_id:this.l_id,
              u_id:this.u_id,
              user_id:this.u_id,
          }
          let res = await goldApi.userEvaluationOfTeachers(params);
          if(res.status == "success") {
            this.newsList = res.data;
            this.$srH5CallNativeMethodApp('vip_product_comments',{
              comments_num:this.newsList.length || 0,
            })
          }
          
      },
      //获取当前 购买老师的 相关信息
      async LiveBuyVip(kind) {
          //appversion,user_id
          let params = {
              l_id:this.l_id,
              u_id:this.u_id,
          }
          if(this.g_id){
            params.g_id = this.g_id;
          }
          let res = await goldApi.LiveBuyVip(params);
          if(res.rslt == "success") {
            if(kind=='level'){
              this.user_survey = res.user_survey;
              return false;
            }
            this.livers = res.livers;
            this.livers.agreement_intro = this.livers.agreement_intro.slice(this.livers.agreement_intro.indexOf("《"))
            this.groups = res.groups;
            //单个会员分组 默认勾选； 多个不默认勾选
            if(this.groups.length > 1){
              this.groups_num = -1;
            }
            if(this.g_id){
              this.groups.forEach((item,i)=>{
                if(item.id == this.g_id) {
                  this.groups_num = i;
                }
              })
            }
            console.log('groups_num',this.groups_num)
            this.user = res.user;
            this.user_survey = res.user_survey;
            this.coupons = res.coupons;
            this.products = res.products;

            this.is_invoice_switch = res.is_invoice_switch;

            this.phone = this.livers.company_phone;

            this.tax_title = res.history_invoice.tax_title;
            this.tax_num = res.history_invoice.tax_num;
            this.email = res.history_invoice.email;

            //默认勾选第一个服务期限
            this.choose_product(0,this.vip_kind);
          }
          else{
            alert(res.info);
          }
          
      },
      //支付的接口
      async Payment() {
          var that = this;
          //appversion,user_id
          let params = {
              l_id:this.l_id,
              amount:this.current_product.sale_amount,
              appversion:'11.9.0',
              channel	:'agp_wechat_pay',//微信固定传参
              company:this.livers.company,
              g_id:this.current_group.id,
              have_client:	'yes',
              is_invoice:	'0',
              origin_user_id:	0,
              p_id:this.current_product.id,
              source:'wap',	
              term:this.current_product.term,
              u_id:this.u_id,
              user_id:this.u_id,
          }
          if(this.use_gold){
            //使用金币传参
            params.balance_gold = this.user.gold_total;
          }
          let res = await goldApi.Payment(params);
          if(res.order_no) {
              //有订单号，调支付
              
              //成功后的跳转
              let _str = `/up/app/pay_succ?order=${res.order_no}&l_id=${that.livers.id}&name=${that.livers.title}&time=${that.current_product.term}个月&price=${that.price}&id=${that.livers.agreement_id}`;
              console.log('pingpp',res,_str)
              //return false;
              pingpp.createPayment(res, function (result, err) {
              if (result == "success") {
                // 只有微信公众账号 (wx_pub)、微信小程序 (wx_lite)、QQ 公众号 (qpay_pub)、支付宝口碑 (alipay_qr)
                // 支付成功的结果会在这里返回，其他的支付结果都会跳转到 extra 中对应的 URL。
                that.$message.success("支付成功!");
                let timer = null;
                clearInterval(that.timer_await);
                setTimeout(() => {
                  //let query = that.$route.query;//暂时用不到
                  location.href = _str;
                  clearTimeout(timer);
                }, 1000);
              } else if (result == "fail") {
                that.$message.success("支付失败!");
                // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
              } else if (result == "cancel") {
                //只有在线上生效
                that.$message.success("支付已取消!");
                that.cancel_pop = true;
                // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
              }
            });
          }
          else{
            alert(res.info||'网络原因，请稍后再试')
          }
          
      },
      //同意协议 调用支付
      agree_to(){
        this.show_agreement = false;
        this.use_tip = true;
        this.pay();
      },
      //调用支付 方法
      async pay(){

        //测试跳转到支付页面
        // let that = this;
        // let _str = `/up/app/pay_succ?order=123456&l_id=${that.livers.id}&name=${that.livers.title}&time=${that.current_product.term}个月&price=${that.price}&id=${that.livers.agreement_id}`;
        // console.log('123456',_str);
        // return false;

        //判断一下是否绑定微信 保留接口状态
        if(!this.bindWeChatCheck){
          let bindWeChatCheckRes = await goldApi.bindWeChatCheck({u_id:this.u_id});
          console.log(bindWeChatCheckRes);

          if(bindWeChatCheckRes.code != 1){
            alert(bindWeChatCheckRes.message);
            //
            if(bindWeChatCheckRes.code == 1001){
              //登录 未绑定微信 走绑定微信
              location.href = `/login/bindWeChat?user_id=${this.u_id}&l_id=${this.l_id}`;
              //this.bindWeChat();
            }
            if(bindWeChatCheckRes.code == -1){
              //未登录直接微信登录  携带参数方便后端跳转回此页面
              location.href = `/login/wx_login.html?login_type=server_promotion_wx_login&l_id=${this.l_id}`;
            }
            return false;
          }
          else{
            //确保 已经绑定微信
            this.bindWeChatCheck = true;
          }
        }


        if(this.txt == '签约'){
          //跳转签约
          this.goPage('sign_agreement');
          return false;
        }
        else if(this.txt == '预约成功' || this.txt == '完成'){
          //返回上一级
          this.goPage('go_back_previous');
          return false;
        }



        //this.paying = true;

        if(this.is_wap){

          if(!this.current_group.id){
            alert("请选择会员分组！");
            this.show_group = true;
            return false;
          }

          if(!this.current_product.id){
            alert("请选择服务期限！");
            return false;
          }

          //需要判断是否同意协议
          if(!this.use_tip){
            this.show_agreement = true;
            return false;
          }

          //调用支付接口
          this.Payment();
          return false;
        }

        this.$srH5CallNativeMethodApp('buy_pay',{
          //前端不传信息（优惠券相关、使用金币相关 -- 客户端保存本地
          kind:this.vip_kind,
          is_used_gold:Number(this.use_gold),//是否用金币
          is_invoice:Number(this.use_invoice),//是否开发票
          is_agree_agreement:Number(this.use_tip),//是否同意协议
          user_survey:JSON.stringify(this.user_survey) ,//风险评估
          current_product:JSON.stringify(this.products[this.products_num]),//当前产品
          current_group:JSON.stringify(this.groups[this.groups_num]),//当前分组
          current_invoice:JSON.stringify({
            tax_num:this.tax_num,
            tax_title:this.tax_title,
            email:this.email,
            tax_type:this.invoice_kind,
          }),//当前发票信息
          price:this.price,//最终价格
          livers:JSON.stringify(this.livers),//当前老师信息（协议
          groups:JSON.stringify(this.groups),//所有分组
          pre_user_gold_id:this.pre_user_gold_id,
        })
      },
      //未绑定 走绑定微信接口  改为走url
      // bindWeChat(){
      //   let _this = this;
      //   $.ajax({
      //       xhrFields: { withCredentials: true },
      //       type: "get",
      //       url: `/login/bindWeChat?user_id=${this.u_id}&l_id=${this.l_id}`,
      //       cache: false,
      //       async: true,
      //       error: function () {
      //           return false;
      //       },
      //       success: function (res) {
      //         if(res.code == 1){
      //           alert('微信绑定成功！')
      //           location.href = res.jump_url;
      //         }
      //         else if(res.code == 1001){
      //           //未登录
      //           alert(res.message);
      //           location.href = `/login/wx_login.html?login_type=server_promotion_wx_login&l_id=${this.l_id}`;
      //         }
      //         else{
      //           alert(res.message);
      //         }
      //       },
      //   })
      // }
    },

}

</script>
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";

    .show_phone_wrap{
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background:rgba(0, 0, 0, 0.4) ;
      display: flex;
      align-items: center;
      justify-content: center;
      .show_phone{
        display: flex;
        width: rem2(240px);
        //height: rem2(280px);
        padding: 0px rem2(12px) rem2(12px);
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        background: #fff;
        border-radius: rem2(8px);
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
        color: #333;
        font-size: rem2(14px);
        h1{
          font-size: rem2(16px);
          line-height:262.5% /*  */
        }
        h2{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          align-self: stretch;
          border-radius: rem2(4px);
          height: rem2(34px);
          border: rem2(1px) solid #DCDCDC;
        }
        p{
          height: 50px;
          line-height: 40px;
        }
      }
    }
    .app_wrap{
        background: #FAFAFA;
        padding-bottom: rem2(80px);
        -webkit-overflow-scrolling: touch;
    }

    .invite{
      position: fixed;
      top: rem2(48px);
      right: rem2(8px);
      width: rem2(71.5px);
      height: rem2(71.5px);
      flex-shrink: 0;

      .invite_img{
        width: 100%;
        height: 100%;
        background-size: 100%;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/vip_in.svg);

      }
      
     
      .in_close{
        left: 0;
        top: 0;
        position: absolute;
        width: rem2(21px);
        height: rem2(21px);
        flex-shrink: 0;
        background-size: 100%;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/vip_c.svg);

      }
    }

    .live_wrap{
      padding: rem2(18px) rem2(12px);
      display: flex;
      .live_img{
        margin-right: rem2(10px);
        width: rem2(60px);
        height: rem2(60px);
        border-radius: rem2(60px);
        background: url('') lightgray 50% / cover no-repeat;
      }
      .live_c{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      h1{
        color: #FF443D;
        font-size: rem2(16px);
        font-weight: 500;
      }
      p{
        color: #636363;
        font-size: rem2(13px);
      }
    }

    .buy_wrap{
      border-top: rem2(1px) solid #EBEBEB;
      border-bottom: rem2(1px) solid #EBEBEB;
      background: #fff;
      padding: rem2(5px) rem2(10px);
      display: flex;
      align-items: center;
      margin-bottom:  rem2(10px);
      >svg{
        width: rem2(20px);
        height: rem2(20px);
        flex-shrink: 0;
        margin-right: rem2(8px);
      }
      h1{
        color: #333;
        font-size: rem2(15px);
        margin-right: rem2(6px);
        span{
          color: #636363;
          margin-left: rem2(8px);
          font-size: rem2(13px);
        }
      }
      .red{
        color:#FF443D;
      }
      .red_mini{
        font-size: 14px;
      }
      .c13{
        font-size: rem2(13px);
      }
      .c63{
        color: #636363;
      }
      .buy_content{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        
        p{
          color:#939393;
          font-size: rem2(11px);
          margin-top: rem2(5px);
        }
      }
      .buy_close{
        display: flex;
        align-items: center;
        >svg{
          width: rem2(12.5px);
          height: rem2(25px);
          flex-shrink: 0;
          &.check{
            width: rem2(22px);
            height: rem2(22px);
          }
        }
      }
    }
    .buy_wrap_no{
      margin-bottom: 0;
      border-bottom: none;
      padding-bottom: 0;
    }

    .buy_wrap_no2{
      margin-bottom: 0;
      border-bottom: none;
    }

    .buy_wrap_h{
      padding-top: 10px;
      padding-bottom: 10px;
    }

    span.buy_wrap_no2span{
      display: flex;
      height: rem2(20px);
      justify-content: center;
      align-items: center;
      color: #0099D2;
      font-size: rem2(12px);
      border-radius: rem2(2px);
      border: rem2(1px) solid #00AEEF;
      padding: 0 rem2(2px);
      margin-right: rem2(10px);
    }

    .buy_wrap_no3{
      margin-bottom: 0;
    }

    .invoice_box{
      .invoice_i{
        display: flex;
        align-items: center;
        padding: rem2(10px) rem2(12px);
        background: #fff;
        border-bottom: rem2(1px) solid #EBEBEB;
      }
      .invoice_c{
        display: flex;
        align-items: center;
      }
      .invoice_c1{
        font-size: rem2(14px);
        display: flex;
        align-items: center;
      }
      .invoice_c2{
        margin-right: rem2(20px);
      }
      input{
        font-size: rem2(15px);
        flex: 1;
      }
      svg{
        width: rem2(22px);
        height: rem2(22px);
        flex-shrink: 0;
        margin-right: rem2(5px);
      }
      h1{
        color: #333;
        font-size: rem2(15px);
        margin-right: rem2(32px);
        width: rem2(60px);
        flex-shrink: 0;
        white-space: nowrap;
      }
      p{
        color: #939393;
        font-size: rem2(12px);
        line-height: rem2(20px);
      }
    }

    .discussion-board-box{
      padding-left: 40px;
      background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app_vip_c.svg) no-repeat;
      background-size: 16px;
      background-position: 12px center;
    }

    .vip_wrap{
      padding: rem2(12px);
      padding-bottom: 0;
      background: #fff;
      p{
        line-height: rem2(18px);
        color: #636363;
        font-size: rem2(12px);
      }
      >p{
        padding-bottom: rem2(12px);
      }
      .red{
        color:#FF443D;
        text-decoration-line: underline;
      }
      .vip_item{
        border-radius: rem2(6px);
        border: rem2(1px) solid #DCDCDC;
        display: flex;
        align-items: center;
        padding:rem2(6px) rem2(10px) ;
        justify-content: space-between;
        margin-bottom: rem2(10px);
        h1{
          color: #FF443D;
          font-size: rem2(15px);
          font-weight: 500;
          line-height: rem2(23px);
          margin-bottom: rem2(1px);;
        }
        h2{
          color: #939393;
          font-size: rem2(11px);
          line-height: rem2(11px); /* 100% */
        }

        .vip_r{
          h1{
            color:#333;
          }
          span{
            margin-right: rem2(6px);
            color: #FF443D;
            padding: rem2(1px) rem2(5px);
            border-radius: rem2(4px);
            font-size: rem2(10px);
            border: rem2(1px) solid #FF443D;
          }
          h2{
            text-decoration-line: line-through;
            text-align: right;
          }
        }
      }

      .vip_item2{
        border-color: #FF443D;
      }
    }

    .bottom{
      width: rem2(375px);
      height: rem2(86.5px);
      flex-shrink: 0;
      background-size: 100%;
      background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/vip_in2.svg);

    }

    .contact{
      display: flex;
      width: 100%;
      height: rem2(45px);
      background: #fff;
      .contact_o{
        position: relative;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        color: #333;
        font-size: rem2(15px);
        svg{
          width: rem2(22px);
          height: rem2(22px);
          margin-right: rem2(5px);
        }
      }

      .contact_o2::before{
        display: block;
        content: "";
        height: rem2(45px);
        width: rem2(1px);
        background: #EBEBEB;
        position: absolute;
        left: 0;
        top: 0;
      }


    }

    .tip_w{
      padding: rem2(10px) rem2(12px)  0;
      border-top: rem2(1px) solid #ebebeb;
      .tip_o{
        p{
          color: #636363;
          font-size: rem2(13px);
          line-height: rem2(20px);
          span{
            color:#1D88D0;
          }
        }
        display: flex;
        padding-bottom: rem2(10px);

        svg{
          width: rem2(22px);
          height: rem2(22px);
          margin-right: rem2(8px);
          flex-shrink: 0;
        }
      }
    }

    .buy_box{
      position: fixed;
      bottom: 0;
      display: flex;
      height: rem2(52px);
      padding: rem2(8px) rem2(13px) rem2(8px) rem2(10px);
      border-top: rem2(1px) solid #EBEBEB;
      background: #FFF;
      width: 100%;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;

      .buy_box_l{
        color: #FF443D;
        font-size: rem2(17px);
        span{
          font-size: rem2(24px);
        }
        
      }
      .buy_box_l_n{
        opacity: 0;
      }

      .buy_box_r{
        border-radius: rem2(20px);
        background: #FF443D;
        display: flex;
        //width: rem2(100px);
        padding: 0 rem2(30px);
        height: rem2(36px);
        justify-content: center;
        align-items: center;
        color: #FFF;
        font-size: rem2(16px);

      }

      .buy_box_b{
        background: #3385FF;
      }

    }
    .show_agreement{
      width: 100%;
      position: fixed;
      bottom: 0;
      font-size: rem2(15px);
      color: #333;
      background: #F1F2F3;
      svg{
        width: rem2(16px);
        height: rem2(16px);
        flex-shrink: 0;
      }
      h1{
        font-size: rem2(17px);
        background: #F5F6F7;
        height: rem2(42px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
      span{
        display: flex;
        align-items: center;
        height: rem2(56px);
        padding: 0 rem2(10px);
        border-top: rem2(1px) solid #EBEBEB;
        background: #fff;
        justify-content: space-between;
      }
      .flex{
        display: flex;
        height: rem2(50px);
        margin-top: rem2(10px);
        
        span{
          width: 50%;
          height: rem2(50px);
          justify-content: center;
          border: none;
          padding: 0;
          color: #FF443D;

          &:first-of-type{
            color: #636363;
            position: relative;
            border-right: rem2(1px) solid #EBEBEB;
          }
          &.one{
            width: 100%;
          }

          svg{
            height: 19px;
            width: 19px;
            margin-right: 2px;
          }
        }
      }

      .show_group_detail{
        display: flex;
        padding: 12px 16px 40px 16px;
        //justify-content: center;
        align-items: center;
        border-bottom: 0.5px solid #EBEBEB;
        background: #FFF;
      }

    }

    .show_group_class_wrap{
      width: 100%;
      position: fixed;
      bottom: 0;
      font-size: rem2(15px);
      color: #333;
      background: #F1F2F3;
      >h1{
        font-size: rem2(17px);
        background: #F5F6F7;
        height: rem2(42px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
      .show_group_class{
        display: flex;
        align-items: center;
        padding: 8px rem2(16px);
        border-top: rem2(1px) solid #EBEBEB;
        background: #fff;
        justify-content: space-between;
        min-height: 25px;
        svg{
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          &.can_order_not{
            fill:#ebebeb;
          }
        }
        .show_group_lef{
          >h1{
            background: #fff;
            color: #333;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            span{
              display: inline-flex;
              padding: 1.5px 4px;
              justify-content: center;
              align-items: center;
              border-radius: 4px;
              background: #ED7253;
              color: #fff;
              font-size: 12px;
              height: auto;
              &.can_order{
                background:#1989fac9;
              }

              &.can_order_not{
                background:#c8c9cc;
              }
            }
          }
          >h2{
            margin-top: 5px;
            color: #939393;
            font-size: 12px;
            svg{
              width: 4.308px;
              height: 8px;
            }
          }

        }

      }
      .flex{
        display: flex;
        height: rem2(50px);
        margin-top: rem2(10px);
        
        span{
          width: 50%;
          height: rem2(50px);
          justify-content: center;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border: none;
          padding: 0;
          color: #FF443D;

          &:first-of-type{
            color: #636363;
          }
          &.one{
            width: 100%;
          }
        }
      }
    }

    .order_open2{
      color: #636363;
      font-size: rem2(13px);
      line-height: normal;
      padding: 0 rem2(12px);
    }


    .wap_img{
      display: inline-block;
      position: relative;
        >img{
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          left: 0;
          top: 0;
      }
    }  


    .show_gold_tip_class{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .show_gold_tip_class_close{
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        margin-bottom: 15px;
        background-size: 100%;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/app_xjzf_c.svg);

      }
      .show_gold_tip_wrap{
        display: flex;
        width: 315px;
        padding: 12px;
        flex-direction: column;
        align-items: center;
        border-radius: 6px;
        background: #FFF;
        line-height: 1.5;
        h1{
          color: #333;
          text-align: center;
          font-size: 17px;
          font-weight: bold;
          margin-bottom: 18px;
        }
        h2{
          color: #D96058;
          font-size: 22px;
        }
        h3{
          color: #939393;
          font-size: 13px;
          margin-bottom: 18px;
        }
        p{
          color: #636363;
          text-align: center;
          font-size: 13px;
          margin-bottom: 18px;
          line-height: 1.3;
        }
        .xjzf{
          display: flex;
          padding: 10px;
          justify-content: center;
          align-items: center;
          align-self: stretch;
          border-radius: 4px;
          background: #D96058;
          color: #FFF;
          text-align: center;
          font-size: 15px;
        }
      }
    }  

</style>